import axios from './axios'

export const fetchList = params => axios.get('/management/feedback', { params })
export const deleteOne = params => axios.delete('/management/feedback', { data: params })
